import fishingToolRequest from './fishing-tool-request.store';
import licenseRequest from './license-request.store';
import vesselRequest from './vessel-request.store';
import vesselOwnerRequest from './vessel-owner-request.store';
import userRequest from './user-request.store'
import feeStatement from './fee-statement.store'
import linkageNode from './linkage-node.store'
import bookLicenseRequest from './book-license-request.store'
import surveyAnswer from './survey-answer.store'
import fileStore from './file-store.store'

export default {
    fishingToolRequest,
    licenseRequest,
    vesselRequest,
    vesselOwnerRequest,
    userRequest,
    feeStatement,
    linkageNode,
    bookLicenseRequest,
    surveyAnswer,
    fileStore
};
